import * as SignalR from "@microsoft/signalr";
import posthog from "posthog-js";
import { WebStorageNames, WebStorage } from "../../utils";
import { HUB_CONNECTION } from "./hubActionTypes";
import { HOST_URL } from "../../api/endPoints";

export const createHubConnection = () => {
    console.log('=== createHubConnection called ===');
    const response = WebStorage.getLocalStore(WebStorageNames.AuthInfo);
    console.log('Auth info for hub connection:', response);
    console.log('HOST_URL:', HOST_URL);

    if (!response || !response.accessToken) {
        if (typeof posthog !== "undefined" && posthog.capture) {
            posthog.capture("hubConnection", {
                type: "exception",
                success: false,
                reason: "No access token found for hub connection",
            });
        }
        console.log('Available localStorage keys:', Object.keys(localStorage));
        console.log('WebStorage.AuthInfo:', WebStorage.getLocalStore(WebStorageNames.AuthInfo));
        return null;
    }

    console.log('Creating SignalR connection to:', `${HOST_URL}hubs/timeoffnotification`);

    var connection = new SignalR.HubConnectionBuilder()
        .withUrl(`${HOST_URL}hubs/timeoffnotification`, {
            accessTokenFactory: () => {
                console.log('Providing access token for hub connection:', response.accessToken);
                return response.accessToken;
            }
        })
        .withAutomaticReconnect()
        .build();

    console.log('Hub connection created:', connection);
    console.log('Hub connection state:', connection.state);
    return connection;
};

export const hubConnectionCreated = hubConnection => {
    return {
        type: HUB_CONNECTION.STATE.CREATED,
        payload: hubConnection
    };
};

export const onHubGeneralNotification = ({ notification, history }) => ({
    type: HUB_CONNECTION.METHODS.NOTIFICATION_UPDATE,
    payload: { notification, history },
    realTime: true
});

export const hubConnectionClosed = () => {
    return {
        type: HUB_CONNECTION.STATE.CLOSED
    };
};
export const onHubUserLogin = payload => {
    return {
        type: HUB_CONNECTION.METHODS.USER_LOGIN,
        realTime: true,
        payload: payload
    };
};
export const onHubNotificationUpdate = payload => {
    return {
        type: HUB_CONNECTION.METHODS.LEAVE_REQUEST,
        realTime: true,
        payload: payload
    };
};
